module.exports = __webpack_public_path__ + "img/CS4-1.5f966217.png";